<template>
  <div class="progress-wrapper">
    <div class="task-title">
      {{progressText}} {{progress}}%
    </div>
    <div class="progress">
      <div class="progress-bar" :style="`width: ${progress}%`" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TaskProgress',
  props: {
    progress: {
      type: Number,
      default: 0
    },
    progressText: {
      type: String,
      default: '进度'
    },
    color: {
      type: String,
      default: 'rgba(154, 137, 248, 1)'
    }
  }
}

</script>

<style scoped lang="scss">
.progress-wrapper {
  padding: 18px;
  border-radius: 12px;
  border: 2px dashed rgba(151, 151, 151, 0.42);
}
.task-title {
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 19.6px;
  color: rgba(0, 0, 0, 1);
  text-align: left;
  vertical-align: top;
  margin: 0 12px 12px;
}
.progress {
  box-sizing: border-box;
  padding: 5px 8px;
  height: 26px;
  border-radius: 18px;
  background: rgba(240, 243, 253, 1);
}
.progress-bar {
  transition: width 200ms;
  height: 15px;
  border-radius: 8px;
  background: v-bind(color);
}

</style>